import React, { useEffect, useState } from 'react';

const AlphabetLetter = ({letter, removeLetter}) => {

    const handleClick = () => {
        setTimeout(() => {
            removeLetter(letter);
        }, 200)
    }

    return (
        <li>
            <button onClick={handleClick}>
                {letter}
                <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1 101L0 90.9L40.4 50.5L0 10.1L10.1 0L50.5 40.4L90.9 0L101 10.1L60.6 50.5L101 90.9L90.9 101L50.5 60.6L10.1 101Z" fill="black"/>
                </svg>
            </button>
        </li>
    );
};

export default AlphabetLetter;